<script setup>
import "@/style/main.scss";
import Default from "@/layouts/DefaultLayout.vue";
import Empty from "@/layouts/EmptyLayout.vue";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const layoutComponent = computed(() => {
  switch (route.meta.layout) {
    case "EmptyLayout":
      return Empty;
    default:
      return Default;
  }
});
</script>

<template>
  <component :is="layoutComponent">
    <RouterView />
  </component>
</template>

<style lang="scss"></style>
